import React from "react";

import { StyledCell, StyledStack } from "./styles";
import { HubHookFormInput, HubHookFormSelect } from "../../components";
import { useFormContext } from "react-hook-form";
import { Formats, getLabels } from "./helper";

const BarcodeValueTableAddRow = ({ handleAdd = () => {} }) => {
  const prefix = "addrow";

  const { getValues, setValue } = useFormContext();

  const value = {
    field: null,
    format: null,
    padding: null,
  };

  const onFieldUpdate = (field) => {
    const value = getValues(`${prefix}.${field}`);
    handleAdd({ [field]: value });
    setValue(prefix, {});
  };

  return (
    <StyledStack sx={{ backgroundColor: "hubColors.mainFocusLighter2" }}>
      <HubHookFormSelect
        name={`${prefix}.field`}
        value={value.field}
        onChange={() => onFieldUpdate("field")}
        options={getLabels(1)}
        required
      />
      <HubHookFormSelect
        name={`${prefix}.format`}
        value={value.format}
        onChange={() => onFieldUpdate("format")}
        options={Formats}
        required
      />
      <HubHookFormInput
        name={`${prefix}.padding`}
        value={value.padding}
        onChange={() => onFieldUpdate("padding")}
        placeholder="# of numbers"
        isNumber
      />
      <StyledCell />
    </StyledStack>
  );
};

export default BarcodeValueTableAddRow;
